import { Box, Flex } from "components/Box";
import { Text } from "components/Text";
import styled from "styled-components";
import HeroBackgroundBody from 'assets/Hero/HeroBG-1.svg';

export const CompanyLinksBackgroundImg = styled.div`
    background-image: url(${HeroBackgroundBody});
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    width: 100%;

    ${({ theme }) => theme.mediaQueries.xs} {
        height: 60vh;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        height: 75vh;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        height: 110vh;
        padding: 60px 0px;
    }
    a{
        color: ${(props) => props.theme.colors.primary};
    }
`

export const CompanyHeadings = styled(Text)`
    color: ${(props) => props.theme.colors.primary};
`
export const CompanyParagraphTexts = styled(Text)`
    font-size: 18px;
    line-height: 40px;
    text-align: justify;

    a{
        text-decoration: none;
    }
    a:hover{
            color: ${(props) => props.theme.colors.text};
            text-decoration: none;
        }
`

export const CompanyParagraphTextsLinks = styled(Text)`
    a{
        color: ${(props) => props.theme.colors.text};
        text-decoration: none;
        font-size: 18px;
    }
    a:hover{
        color: ${(props) => props.theme.colors.primary};
        font-size: 18px;
        text-decoration: none;
    }
`

export const CompanyOrderdList = styled(Flex)`
    & li::marker{
        color: ${(props) => props.theme.colors.primary};
    }

    & li{
        color: ${(props) => props.theme.colors.text};
        font-size: 18px;
        line-height: 40px;
    }
`
export const CompanyImg = styled(Box)`
    margin: 50px;
`